import { render, staticRenderFns } from "./ListTransfers.vue?vue&type=template&id=34e97635&"
import script from "./ListTransfers.vue?vue&type=script&lang=js&"
export * from "./ListTransfers.vue?vue&type=script&lang=js&"
import style0 from "./ListTransfers.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports